__turbopack_context__.v({
  "auFieldFill": "app-screen-module__DvQYTa__auFieldFill",
  "boardIndent": "app-screen-module__DvQYTa__boardIndent",
  "boardName": "app-screen-module__DvQYTa__boardName",
  "boardNameCard": "app-screen-module__DvQYTa__boardNameCard",
  "boardNameHero": "app-screen-module__DvQYTa__boardNameHero",
  "boardNameText": "app-screen-module__DvQYTa__boardNameText",
  "boardNr": "app-screen-module__DvQYTa__boardNr",
  "colHead": "app-screen-module__DvQYTa__colHead",
  "colHeadLeft": "app-screen-module__DvQYTa__colHeadLeft",
  "colHeadRight": "app-screen-module__DvQYTa__colHeadRight",
  "colLabel": "app-screen-module__DvQYTa__colLabel",
  "columnLabel": "app-screen-module__DvQYTa__columnLabel",
  "columnLabelRow": "app-screen-module__DvQYTa__columnLabelRow",
  "columnLabelText": "app-screen-module__DvQYTa__columnLabelText",
  "field": "app-screen-module__DvQYTa__field",
  "fieldFilled": "app-screen-module__DvQYTa__fieldFilled",
  "fieldLabel": "app-screen-module__DvQYTa__fieldLabel",
  "fieldLabelRoomy": "app-screen-module__DvQYTa__fieldLabelRoomy",
  "fieldRoomy": "app-screen-module__DvQYTa__fieldRoomy",
  "header": "app-screen-module__DvQYTa__header",
  "headerCard": "app-screen-module__DvQYTa__headerCard",
  "headerDetail": "app-screen-module__DvQYTa__headerDetail",
  "headerHero": "app-screen-module__DvQYTa__headerHero",
  "headerLeading": "app-screen-module__DvQYTa__headerLeading",
  "headerRight": "app-screen-module__DvQYTa__headerRight",
  "headerSlash": "app-screen-module__DvQYTa__headerSlash",
  "headerTitle": "app-screen-module__DvQYTa__headerTitle",
  "pill": "app-screen-module__DvQYTa__pill",
  "pillCard": "app-screen-module__DvQYTa__pillCard",
  "pillDashed": "app-screen-module__DvQYTa__pillDashed",
  "pillEmpty": "app-screen-module__DvQYTa__pillEmpty",
  "pillHero": "app-screen-module__DvQYTa__pillHero",
  "pillRinged": "app-screen-module__DvQYTa__pillRinged",
  "root": "app-screen-module__DvQYTa__root",
  "stat": "app-screen-module__DvQYTa__stat",
  "statLabel": "app-screen-module__DvQYTa__statLabel",
  "statValue": "app-screen-module__DvQYTa__statValue",
  "statusBadge": "app-screen-module__DvQYTa__statusBadge",
  "statusBadgeOutlined": "app-screen-module__DvQYTa__statusBadgeOutlined",
  "subHeader": "app-screen-module__DvQYTa__subHeader",
  "subHeaderCard": "app-screen-module__DvQYTa__subHeaderCard",
  "subHeaderHero": "app-screen-module__DvQYTa__subHeaderHero",
  "subHeaderRowLabel": "app-screen-module__DvQYTa__subHeaderRowLabel",
  "subHeaderTracked": "app-screen-module__DvQYTa__subHeaderTracked",
  "tag": "app-screen-module__DvQYTa__tag",
  "track": "app-screen-module__DvQYTa__track",
  "trackFill": "app-screen-module__DvQYTa__trackFill",
});
